<template>
    <div v-if="!isRoot" class="container-fluid">
      <div class="page-title">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{ getTranslation(route.meta.headTitle) }}</h3>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/' }">
                  <svg class="stroke-icon">
                    <use href="@/assets/svg/icon-sprite.svg#stroke-home"></use>
                  </svg>
                </router-link>
              </li>
              <template v-for="(crumb, index) in breadcrumbs" :key="crumb.name ?? index">
                <li
                  v-if="crumb.link"
                  class="breadcrumb-item"
                  :class="{ active: index === breadcrumbs.length - 1 }"
                >
                  <router-link :to="crumb.to" :class="{ 'text-body text-decoration-underline' : index !== breadcrumbs.length - 1 }">
                    {{ getTranslation(crumb.label) }}
                  </router-link>
                </li>
                <li v-else class="breadcrumb-item" :class="{ active: index === breadcrumbs.length - 1 }">
                  {{ getTranslation(crumb.label) }}
                </li>
              </template>
            </ol>
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const { t } = useI18n();

const isRoot = computed(() => route.name === 'defaultRoot');

function getTranslation(key) {
  if (!key) return '';
  const globalKey = `global.${key}`;
  const globalTranslation = t(globalKey);
  if (globalTranslation !== globalKey) {
    return globalTranslation;
  }
  return key;
}

const breadcrumbs = computed(() => {
  const items = [];
  const matched = route.matched;

  for (let i = 0; i < matched.length; i++) {
    const record = matched[i];
    const label = record.meta?.breadcrumb;
    if (label) {
      const isLast = i === matched.length - 1;
      const hasLink = record.name && !isLast;
      items.push({
        label,
        name: record.name,
        to: hasLink ? { name: record.name, params: route.params } : undefined,
        link: hasLink,
      });
    }
  }
  return items;
});
</script>
